import React, {useCallback, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {fetchSrpDataThunk} from '../../redux/thunks';

import {
  ISrpConfig,
  IUpdate_Srp_Config,
  UPDATE_SRP_CONFIG,
  UPDATE_FILTER,
  IUpdate_Filter,
} from '../../redux/types';
import {srpConfigSelectorFn, staticFilterLocationsListSelector, overrankVhidSelectorFn} from '../../redux/selectors';
import {cityIdSelectorFn} from '../../../common/redux/selectors';
import {resetFilterAction} from '../../redux/actions';

import LocationAndHotelSearch from '../../../../../stories/components/hotels/SRP/Autosuggests/LocationAndHotelSearch/LocationAndHotelSearch';

import scrollToTop from '../../../../../shared/utils/scrollToTop';

const RefineSearch = () => {
  const dispatch = useDispatch();

  const cityId = useSelector(cityIdSelectorFn);
  const srpConfig = useSelector(srpConfigSelectorFn);
  const overrankVhid = useSelector(overrankVhidSelectorFn);

  const {
    locationFilterCheckboxList: staticFilterLocationsList,
    staticLocationsNamesIdMap,
  } = useSelector(staticFilterLocationsListSelector);

  const {filter: appliedFiltersInState, s: sortingValue} = srpConfig as ISrpConfig;

  const {location_search: locationFilterState} = appliedFiltersInState;

  const [landmarkOrAreaSelected, setLandmarkOrAreaSelected] = useState(null);

  const updateSrpConfigCaller = useCallback(
    (actionData: IUpdate_Srp_Config['actionData'], resetFilters = false) => {
      dispatch({type: UPDATE_SRP_CONFIG, actionData});
      if (resetFilters) {
        dispatch(resetFilterAction());
        updateFilterCaller();
      }
      // if(callApi)
      // dispatch(fetchSrpDataThunk());
    },
    [dispatch],
  );

  // const updateSrpConfigCaller = useCallback(
  //   (actionData: IUpdate_Srp_Config['actionData']) => {
  //     dispatch({type: UPDATE_SRP_CONFIG, actionData});
  //     dispatch(fetchSrpDataThunk());
  //   },
  //   [dispatch],
  // );

  const updateFilterCaller = useCallback(
    (actionData: IUpdate_Filter['actionData'], callApi = true) => {
      scrollToTop();
      dispatch({type: UPDATE_FILTER, actionData});
      if (callApi) dispatch(fetchSrpDataThunk());
    },
    [dispatch],
  );

  return (
    <>
      <LocationAndHotelSearch
        cityId={cityId}
        landmarkOrAreaSelected={landmarkOrAreaSelected}
        overrankVhid={overrankVhid}
        onItemSelection={changes => {
          if (changes?.selectedItem?.t === 'hotel') {
            updateSrpConfigCaller({overriderankvhids: changes.selectedItem._id}, true);
          }

          if (changes?.selectedItem?.t === 'area' ||
              changes?.selectedItem?.t === 'landmark'
            ) {
            let updatedLocationSearchForStore = [...(locationFilterState || [])];

            if (landmarkOrAreaSelected) {
              // remove the previously applied landmark or area from redux store
              updatedLocationSearchForStore = updatedLocationSearchForStore.filter(
                locationFilter => locationFilter.loc_id !== landmarkOrAreaSelected.loc_id,
              );
            }

            let incomingLocationObj = {};
            if (changes.selectedItem._id) {
              incomingLocationObj = {
                loc_id: changes.selectedItem._id,
                n: changes.selectedItem.n,
                id_type: 'voy',
              };
            } else {
              incomingLocationObj = {
                loc_id:
                  changes.selectedItem &&
                  changes.selectedItem.xtr &&
                  changes.selectedItem.xtr.ggl_id
                    ? changes.selectedItem.xtr.ggl_id
                    : '',
                n: changes.selectedItem && changes.selectedItem.n ? changes.selectedItem.n : '',
                id_type: 'ggl_id',
              };
            }

            // set latest location / area filter item in local state
            setLandmarkOrAreaSelected(incomingLocationObj);

            updatedLocationSearchForStore = [...updatedLocationSearchForStore, incomingLocationObj];

            updateFilterCaller({
              location_search: updatedLocationSearchForStore,
            });
          }
        }}
        staticFilterLocationsList={staticFilterLocationsList}
        staticLocationsNamesIdMap={staticLocationsNamesIdMap}
        locationFilterState={locationFilterState}
        updateFilterCaller={updateFilterCaller}
        resetHotelSelection={() => updateSrpConfigCaller({overriderankvhids: ''})}
      />
    </>
  );
};

export default React.memo(RefineSearch);
